module.exports = __webpack_public_path__ + "static/images/delete-bin.2R4qoiW.svg";